<template>
    <div>
        <div>
            在线办公
        </div>
        <div class="list-item">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.list-item {
    width: 1120px;
    height: 140px;
    img {
        width: 210px;
        height: 140px;
        margin: 0 10px;
    }
}
</style>